export const FETCH_USER_PROFILE = "FETCH_USER_PROFILE";

export const fetchUserProfile = (payload) => {
  return {
    type: FETCH_USER_PROFILE,
    payload: payload,
  };
};
